<template>
	<div style="width: 95%;margin: 0 auto;">
		<div
			style="width: 100%;height: 30px;border-left: 3px solid red;margin-top: 25px;font-size: 24px;font-weight: 800;padding-left: 25px;">
			人才招聘系统
		</div>

		<div style="width: 100%;height: 50px;margin-top: 25px;">
			<div @click="ctm('9')" :class="qbeada === true?'czxa':'zxcas'">
				发布简历
			</div>
			<div @click="ctm('10')" :class="qbeadas === true?'czxa':'zxcas'">
				发布招聘
			</div>
			<div @click="ctm('6')" :class="qbeadass === true?'czxa':'zxcas'">
				简历预览
			</div>
			<div @click="ctm('7')" :class="qbeadasss === true?'czxa':'zxcas'">
				招聘预览
			</div>
		</div>

		<!-- <div style="width: 90%;margin-left: 3%;height: 40px;margin-top: 25px;box-shadow: #6e6e6e 0px 0px 10px;">
			<div
				style="width: 820px;height: 30px;font-weight: 800;text-align: center;line-height: 30px;font-size: 18px;margin-left: 20px;">
				<el-radio-group v-model="cid" @change="gotosb()">
					<el-radio-button label="9">发布简历</el-radio-button>
					<el-radio-button label="10">发布招聘</el-radio-button>
					<el-radio-button label="6">简历预览</el-radio-button>
					<el-radio-button label="7">招聘预览</el-radio-button>
				</el-radio-group>
			</div>
		</div> -->

		<div style="width: 100%;min-height: 300px;margin-top: 25px;">
			<div v-show="this.cid=='9'" style="min-height: 300px;">
				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						应聘职务名称:
					</div>
					<el-input v-model="form.title" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						头像:
					</div>
					<el-upload class="upload-demo" style="width: 200px;height: 30px;float: left;margin-top: 10px;"
						action="https://admin.shipoe360.com/api/picture/upload_pic" :on-preview="handlePreview"
						:on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handsuccessssq" :limit="1"
						:on-exceed="handleExceed" :file-list="fileListssq">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
				</div>
				
				<div style="width: 100%;height: 50px;margin-top: 20px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						微信二维码:
					</div>
					<el-upload class="upload-demo" style="width: 200px;height: 30px;float: left;margin-top: 10px;"
						action="https://admin.shipoe360.com/api/picture/upload_pic" :on-preview="handlePreview"
						:on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handsuccessssqsssss" :limit="1"
						:on-exceed="handleExceed" :file-list="fileListssqss">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
				</div>

				<div style="width: 100%;height: 50px;margin-top: 25px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						真实姓名:
					</div>
					<el-input v-model="form.name" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<!-- <div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						期望薪资:
					</div>
					<el-input v-model="form.money" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div> -->
				
				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						期望薪资:
					</div>
					<!-- <el-input v-model="form.money" style="float: left;width: 70%;margin-top: 5px;"></el-input> -->
					<el-radio-group v-model="form.money" style="margin-top: 5px;">
						<el-radio-button label="3k-5k">3k-5k</el-radio-button>
						<el-radio-button label="5k-8k">5k-8k</el-radio-button>
						<el-radio-button label="8k-10k">8k-10k</el-radio-button>
						<el-radio-button label="10k+">10k+</el-radio-button>
					</el-radio-group>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						年龄:
					</div>
					<el-input v-model="form.age" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<!-- <div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						学历:
					</div>
					<el-input v-model="form.xueli" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div> -->
				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						学历:
					</div>
					<el-radio-group v-model="form.xueli" style="margin-top: 5px;">
						<el-radio-button label="无要求">无要求</el-radio-button>
						<el-radio-button label="专科">专科</el-radio-button>
						<el-radio-button label="本科">本科</el-radio-button>
						<el-radio-button label="硕士">硕士</el-radio-button>
						<el-radio-button label="博士">博士</el-radio-button>
					</el-radio-group>
				</div>
				
				<div style="width:100%;height:50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						城市选择:
					</div> 
						<el-select size="small" style="width: 150px;float: left;margin-top: 10px;" v-model="selectProv" placeholder="请选择省份"
							v-on:change="getProv($event)">
							<el-option v-for="item in provs" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
						<el-select size="small" style="width: 150px;float: left;margin-top: 10px;" v-if="selectProv!=''" v-model="selectCity"
							placeholder="请选择城市" v-on:change="getCity($event)">
							<el-option v-for="item in citys" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
				</div>
				
				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						状态:
					</div>
					<el-radio-group v-model="form.status" style="margin-top: 5px;">
						<el-radio-button label="1">在职</el-radio-button>
						<el-radio-button label="2">离职</el-radio-button>
					</el-radio-group>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						专业:
					</div>
					<el-input v-model="form.zhuanye" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>
				
				<!-- <div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						工作经验:
					</div>
					<el-input v-model="form.jobexperience" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div> -->
				
				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						工作经验:
					</div>
					<!-- <el-input v-model="form.jobexperience" style="float: left;width: 70%;margin-top: 5px;"></el-input> -->
					<el-radio-group v-model="form.jobexperience" style="margin-top: 5px;">
						<el-radio-button label="1年以内">1年以内</el-radio-button>
						<el-radio-button label="1-3年">1-3年</el-radio-button>
						<el-radio-button label="3-5年">3-5年</el-radio-button>
						<el-radio-button label="5年以上">5年以上</el-radio-button>
					</el-radio-group>
				</div>
				

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						手机号:
					</div>
					<el-input v-model="form.phone" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>
				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						邮箱:
					</div>
					<el-input v-model="form.email" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<!-- <div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						个人优势:
					</div>
					<el-input v-model="form.advantage" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div> -->

				<div style="width: 100%;height: 550px;">
					<div style="width: 40%;height: 50px;float: left;line-height: 50px;text-align: center;">
						简介 <span style="font-size: 12px;">上传图片大小控制再“600 x 350”之间)</span> :
					</div>
					<div style="float: left;width: 90%;margin-left: 5%;height: 500px;">
						<vue-tinymce v-model="form.content" :setting="setting" />
					</div>
				</div>

				<!-- <div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						期望职位:
					</div>
					<el-input v-model="form.position" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div> -->

				<!-- <div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						工作经历:
					</div>
					<el-input v-model="form.experience" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div> -->


				<!-- <div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						资格证书:
					</div>
					<el-input v-model="form.qualification" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div> -->

				<!-- <div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						社交主页:
					</div>
					<el-input v-model="form.homepage" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						志愿服务经历:
					</div>
					<el-input v-model="form.volunteer" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div> -->


				<div style="height: 50px;width: 200px;margin: 0 auto;">
					<el-button type="primary" @click="onSubmit">立即创建</el-button>
				</div>


			</div>
			
			<!-- 公司 -->
			
			<div v-show="this.cid=='10'" style="min-height: 300px;">
				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						招聘职务名称:
					</div>
					<el-input v-model="form.title" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>
				
				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						联系人姓名:
					</div>
					<el-input v-model="form.name" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>
				
				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						联系人手机号:
					</div>
					<el-input v-model="form.phone" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>
				
				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						联系人邮箱:
					</div>
					<el-input v-model="form.email" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>
				
				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						学历:
					</div>
					<el-radio-group v-model="form.xueli" style="margin-top: 5px;">
						<el-radio-button label="无要求">无要求</el-radio-button>
						<el-radio-button label="专科">专科</el-radio-button>
						<el-radio-button label="本科">本科</el-radio-button>
						<el-radio-button label="硕士">硕士</el-radio-button>
						<el-radio-button label="博士">博士</el-radio-button>
					</el-radio-group>
				</div>

				

				<!-- <div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						地区:
					</div>
					<el-select v-model="form.city" filterable placeholder="请选择" style="margin-top: 5px;">
						<el-option v-for="item in optionss" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div> -->

				<div style="width:100%;height:50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						城市选择:
					</div>
						<el-select size="small" style="width: 150px;float: left;margin-top: 10px;" v-model="selectProv" placeholder="请选择省份"
							v-on:change="getProv($event)">
							<el-option v-for="item in provs" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
						<el-select size="small" style="width: 150px;float: left;margin-top: 10px;" v-if="selectProv!=''" v-model="selectCity"
							placeholder="请选择城市" v-on:change="getCity($event)">
							<el-option v-for="item in citys" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						公司全名:
					</div>
					<el-input v-model="form.enterprise" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						工作性质:
					</div>
					<el-radio-group v-model="form.work_type" style="margin-top: 5px;">
						<el-radio-button label="全职">全职</el-radio-button>
						<el-radio-button label="兼职">兼职</el-radio-button>
						<el-radio-button label="实习">实习</el-radio-button>
					</el-radio-group>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						公司规模:
					</div>
					<el-radio-group v-model="form.scope" style="margin-top: 5px;">
						<el-radio-button label="小型企业">小型企业</el-radio-button>
						<el-radio-button label="中型企业">中型企业</el-radio-button>
						<el-radio-button label="大型企业">大型企业</el-radio-button>
					</el-radio-group>
				</div>

				<!-- <div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						公司规模:
					</div>
					<el-radio-group v-model="form.jobexperience" style="margin-top: 5px;">
						<el-radio-button label="1">1年以内</el-radio-button>
						<el-radio-button label="2">1-3年</el-radio-button>
						<el-radio-button label="3">3-5年</el-radio-button>
						<el-radio-button label="4">5-10年</el-radio-button>
						<el-radio-button label="5">10年以上</el-radio-button>
					</el-radio-group>
				</div> -->

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						薪资:
					</div>
					<!-- <el-input v-model="form.money" style="float: left;width: 70%;margin-top: 5px;"></el-input> -->
					<el-radio-group v-model="form.money" style="margin-top: 5px;">
						<el-radio-button label="3k-5k">3k-5k</el-radio-button>
						<el-radio-button label="5k-8k">5k-8k</el-radio-button>
						<el-radio-button label="8k-10k">8k-10k</el-radio-button>
						<el-radio-button label="10k+">10k+</el-radio-button>
					</el-radio-group>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						福利:
					</div>
					<el-input v-model="form.fuli" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>
				

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						工作经验:
					</div>
					<!-- <el-input v-model="form.jobexperience" style="float: left;width: 70%;margin-top: 5px;"></el-input> -->
					<el-radio-group v-model="form.jobexperience" style="margin-top: 5px;">
						<el-radio-button label="1年以内">1年以内</el-radio-button>
						<el-radio-button label="1-3年">1-3年</el-radio-button>
						<el-radio-button label="3-5年">3-5年</el-radio-button>
						<el-radio-button label="5年以上">5年以上</el-radio-button>
					</el-radio-group>
				</div>

				<div style="width: 100%;height: 50px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						展示图片:
					</div>
					<el-upload class="upload-demo" style="width: 200px;height: 30px;float: left;margin-top: 10px;"
						action="https://admin.shipoe360.com/api/picture/upload_pic" :on-preview="handlePreview"
						:on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handsuccesss" :limit="1"
						:on-exceed="handleExceed" :file-list="fileListss">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
				</div>

				<div style="width: 100%;height: 550px;margin-top: 20px;">
					<div style="width: 40%;height: 50px;float: left;line-height: 50px;text-align: center;">
						简介 <span style="font-size: 12px;">上传图片大小控制再“600 x 350”之间)</span> :
					</div>
					<div style="float: left;width: 90%;margin-left: 5%;height: 500px;">
						<vue-tinymce v-model="form.content" :setting="setting" />
					</div>
				</div>

				<div style="width: 100%;height: 50px;margin-top: 25px;margin-bottom: 25px;">
					<div style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;">
						企业图片:
					</div>
					<el-upload class="upload-demo" style="width: 200px;height: 30px;float: left;margin-top: 10px;"
						action="https://admin.shipoe360.com/api/picture/upload_pic" :on-preview="handlePreview"
						:on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handsuccessss" :limit="1"
						:on-exceed="handleExceed" :file-list="fileLists">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
				</div>

				<div style="height: 50px;width: 200px;margin: 0 auto;">
					<el-button type="primary" @click="onSubmit">立即创建</el-button>
				</div>

			</div>
			<div v-show="this.cid=='6'" style="min-height: 300px;text-align: center;">
				<div style="height: 100px;width: 100%;border-bottom: 1px dashed #6e6e6e;" v-for="(item,index) in rczpa">
					<div style="width: 50%;height: 100px;float: left;">
						<div style="width: 70%;height: 50px;line-height: 50px;text-align: left;color: #000;float: left;overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;font-size: 20px;font-weight: 800;">
							{{item.title}}
						</div>
						<!-- <div v-show="item.status=='0'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div>
						<div v-show="item.status=='1'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div>
						<div v-show="item.status=='2'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div> -->
						<div style="width: 100%;height: 50px;line-height: 60px;float: left;text-align: left;">
							<span class="el-icon-time"></span>
							<span>发布时间：</span>{{getLocalTime(item.create_time)}}
						</div>
					</div>
					<div style="width: 50%;height: 100px;float: left;position: relative;">
						<div @click="xiugaia(item)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 20px;border: 1px solid #6e6e6e;">
							修改
						</div>  
						<!-- qzzpdetailist -->
						<!-- <router-link tag="div" :to="{ path:'/qzzpdetail',query:{id:item.id,title:item.title} }" -->
						<router-link tag="div" :to="{ path:'/qzzpdetailist',query:{id:item,title:item.title} }"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 130px;border: 1px solid #6e6e6e;color: blue;">
							查看
						</router-link>
						<div @click="detela(item.id,item.mid)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;bottom: 10px;right: 20px;border: 1px solid #6e6e6e;">
							删除
						</div>
					</div>
				</div>
				<!-- 分页 -->
				<div style="height: 40px;text-align: center;margin-top: 55px;">
					<el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage"
						:page-size="PageSize" layout="total, prev, pager, next" :total="Totals">
					</el-pagination>
				</div>
			</div>
			<div v-show="this.cid=='7'" style="min-height: 300px;text-align: center;">
				<div style="height: 100px;width: 100%;border-bottom: 1px dashed #6e6e6e;" v-for="(item,index) in rczpa">
					<div style="width: 50%;height: 100px;float: left;">
						<div style="width: 70%;height: 50px;line-height: 50px;text-align: left;color: #000;float: left;overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;font-size: 20px;font-weight: 800;">
							{{item.title}}
						</div>
						<!-- <div v-show="item.status=='0'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div>
						<div v-show="item.status=='1'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div>
						<div v-show="item.status=='2'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div> -->
						<div style="width: 100%;height: 50px;line-height: 60px;float: left;text-align: left;">
							<span class="el-icon-time"></span>
							<span>发布时间：</span>{{getLocalTime(item.create_time)}}
						</div>
					</div>
					<div style="width: 50%;height: 100px;float: left;position: relative;">
						<div @click="xiugaia(item)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 20px;border: 1px solid #6e6e6e;">
							修改
						</div>
						<!-- <router-link tag="div" :to="{ path:'/qzzpdetailist',query:{id:item,title:item.title} }" -->
						<router-link tag="div" :to="{ path:'/qzzpdetail',query:{id:item.id,title:item.title} }"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 130px;border: 1px solid #6e6e6e;color: blue;">
							查看
						</router-link>
						<div @click="detela(item.id,item.mid)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;bottom: 10px;right: 20px;border: 1px solid #6e6e6e;">
							删除
						</div>
					</div>
				</div>
				<!-- 分页 -->
				<div style="height: 40px;text-align: center;margin-top: 55px;">
					<el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage"
						:page-size="PageSize" layout="total, prev, pager, next" :total="Totals">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				cid: '6',
				xsa: false,
				qid: '',
				province:'',
				city:'',
				rczpa: '',
				fileListssq: [],
				fileListssqss: [],
				fileListss: [],
				fileLists: [],
				setting: {
					menubar: false,
					toolbar: 'code undo redo restoredraft | cut copy paste pastetext | forecolor backcolor bold italic underline strikethrough link anchor | alignleft aligncenter alignright alignjustify outdent indent | \
					styleselect formatselect fontselect fontsizeselect | bullist numlist | blockquote subscript superscript removeformat | \
					table image media charmap emoticons hr pagebreak insertdatetime print preview | fullscreen | bdmap indent2em lineheight formatpainter axupimgs ltr rtl | emoticons help | wordcount',
					toolbar_drawer: "sliding",
					quickbars_selection_toolbar: "removeformat | bold italic underline strikethrough | fontsizeselect forecolor backcolor",
					plugins: "link image media table lists fullscreen quickbars advlist autosave directionality emoticons help imagetools pagebreak preview print wordcount",
					language: 'zh_CN', //本地化设置
					height: 500,
					selector: '#textarea1',
					automatic_uploads: false,
					images_upload_url: 'https://admin.shipoe360.com/ueditorphp/controller.php',
					fontsize_formats: '12px 14px 16px 18px 24px 36px 48px 56px 72px',
					font_formats: '微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;',

				},
				qbeada: false,
				qbeadas: false,
				qbeadass: false,
				qbeadasss: false,
				form: {
					fid: '',
					city: '',
					scope: '',
					work_type: '',
					jobexperience: '',
					xueli: '',
					qytpa: '',
					zstpa: '',
					jobexperience: '',
					applynum:'',
					fuli: '',
					enterprise: '',
					personl_picture:'',
					title: '', //标题
					picture: '', //图片
					content: '', //内容
					phone: '', //手机号
					email: '', //邮箱
					age: '', //年龄
					xueli: '', //学历
					status:'',
					zhuanye: '', //专业
					money: '', //期望薪资
					name: '', //真实姓名
					advantage: '', //个人优势
					position: '', //期望职位
					experience: '', //工作经历
					xm_experience: '', //项目经历
					qualification: '', //资格证书
					homepage: '', //社交主页
					volunteer: '', //志愿服务经历
				},
				currentPage: 1, //当前页
				PageSize: 10, //当前每页数据
				Totals: 100, //总数据条数
				provs: [{
						label: "北京市",
						value: "北京市"
					},
					{
						label: "天津市",
						value: "天津市"
					},
					{
						label: "河北省",
						value: "河北省"
					},
					{
						label: "山西省",
						value: "山西省"
					},
					{
						label: "内蒙古自治区",
						value: "内蒙古自治区"
					},
					{
						label: "辽宁省",
						value: "辽宁省"
					},
					{
						label: "吉林省",
						value: "吉林省"
					},
					{
						label: "黑龙江省",
						value: "黑龙江省"
					},
					{
						label: "上海市",
						value: "上海市"
					},
					{
						label: "江苏省",
						value: "江苏省"
					},
					{
						label: "浙江省",
						value: "浙江省"
					},
					{
						label: "安徽省",
						value: "安徽省"
					},
					{
						label: "福建省",
						value: "福建省"
					},
					{
						label: "江西省",
						value: "江西省"
					},
					{
						label: "山东省",
						value: "山东省"
					},
					{
						label: "河南省",
						value: "河南省"
					},
					{
						label: "湖北省",
						value: "湖北省"
					},
					{
						label: "湖南省",
						value: "湖南省"
					},
					{
						label: "广东省",
						value: "广东省"
					},
					{
						label: "广西壮族自治区",
						value: "广西壮族自治区"
					},
					{
						label: "海南省",
						value: "海南省"
					},
					{
						label: "重庆市",
						value: "重庆市"
					},
					{
						label: "四川省",
						value: "四川省"
					},
					{
						label: "贵州省",
						value: "贵州省"
					},
					{
						label: "云南省",
						value: "云南省"
					},
					{
						label: "西藏自治区",
						value: "西藏自治区"
					},
					{
						label: "陕西省",
						value: "陕西省"
					},
					{
						label: "甘肃省",
						value: "甘肃省"
					},
					{
						label: "青海省",
						value: "青海省"
					},
					{
						label: "宁夏回族自治区",
						value: "宁夏回族自治区"
					},
					{
						label: "新疆维吾尔自治区",
						value: "新疆维吾尔自治区"
					},
					{
						label: "台湾省",
						value: "台湾省"
					},
					{
						label: "香港特别行政区",
						value: "香港特别行政区"
					},
					{
						label: "澳门特别行政区",
						value: "澳门特别行政区"
					}
				],
				citys: [],
				selectProv: '',
				selectCity: '',
				optionss: [{
					value: '1',
					label: '全国'
				}, {
					value: '2',
					label: '北京'
				}, {
					value: '3',
					label: '上海'
				}, {
					value: '4',
					label: '广州'
				}, {
					value: '5',
					label: '深圳'
				}, {
					value: '6',
					label: '杭州'
				}, {
					value: '7',
					label: '天津'
				}, {
					value: '8',
					label: '西安'
				}, {
					value: '9',
					label: '武汉'
				}, {
					value: '10',
					label: '郑州'
				}, {
					value: '11',
					label: '北京'
				}, {
					value: '12',
					label: '上海'
				}, {
					value: '13',
					label: '广州'
				}, {
					value: '14',
					label: '深圳'
				}, {
					value: '15',
					label: '杭州'
				}, {
					value: '16',
					label: '天津'
				}, {
					value: '17',
					label: '西安'
				}, {
					value: '18',
					label: '武汉'
				}, {
					value: '19',
					label: '郑州'
				}, ],
			}
		},
		mounted() {
			this.gotosb()
		},
		components: {
			//市区联动
			companysadd: resolve => require(['@/components/erjiliandong/companys/citys.vue'], resolve)
			// Membershipactivities: resolve => require(['@/components/Membershipactivities'], resolve),
		},
		methods: {
			ctm(val) {
				this.cid = val
				this.gotosb()
				if (val == '9') {
					this.qbeada = true
					this.qbeadas = false
					this.qbeadass = false
					this.qbeadass = false
				} else if (val == '10') {
					this.qbeadas = true
					this.qbeada = false
					this.qbeadass = false
					this.qbeadass = false
				} else if (val == '6') {
					this.qbeadas = false
					this.qbeada = false
					this.qbeadass = true
					this.qbeadasss = false
				} else if (val == '7') {
					this.qbeadas = false
					this.qbeada = false
					this.qbeadass = false
					this.qbeadasss = true
				}
			},
			getLocalTime(nS) {
				return new Date(parseInt(nS) * 1000).toLocaleString().replace(/:\d{1,2}$/, ' ');
			},
			handlePreview(file) {
				console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			},
			handsuccessssq(response, file, fileList) {
				this.form.picture = response.data.path
			},
			handsuccessssqsssss(response, file, fileList) {
				this.form.personl_picture = response.data.path
			},
			handsuccessss(response, file, fileList) {
				this.form.qiye_img = response.data.path
			},
			handsuccesss(response, file, fileList) {
				this.form.zhanshi_img = response.data.path
				// this.form.qytpa = response.data.path
				
			},
			async onSubmit() {
				// console.log(this.form.zstpa)
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				this.fid = '9'
				if (this.xsa == true) {
					if (this.cid == '9') {
						let qbe = await http.post('api/Common/edit', {
							model: 'hr',
							type: 'content',
							mid: '10',
							title: this.form.title,
							name: this.form.name,
							age: this.form.age,
							status:this.form.status,
							picture: this.form.picture,
							volunteer: this.form.volunteer,
							homepage: this.form.homepage,
							qualification: this.form.qualification,
							personl_picture:this.form.personl_picture,
							experience: this.form.experience,
							position: this.form.position,
							advantage: this.form.advantage,
							email: this.form.email,
							phone: this.form.phone,
							zhuanye: this.form.zhuanye,
							xueli: this.form.xueli,
							applynum:this.form.applynum,
							content: this.form.content,
							jobexperience: this.form.jobexperience,
							fuli: this.form.fuli,
							money: this.form.money,
							zhanshi_img: this.form.zhanshi_img,
							qiye_img: this.form.qiye_img,
							xueli: this.form.xueli,
							city: this.city,
							province:this.province,
							jobexperience: this.form.jobexperience,
							scope: this.form.scope,
							work_type: this.form.work_type,
							enterprise: this.form.enterprise,
							fid: this.form.fid,
							uid: loginInfo.id,
							id: this.qid,
						})
						if (qbe.data.code == 200) {
							this.$notify({
								title: '成功',
								message: '上传成功',
								type: 'success'
							});
							this.fileLists = []
							this.fileListss = []
							this.fileListssq = []
							this.fileListssqss = []
							this.form.title = ''
							this.form.fid = ''
							this.city= ''
							this.province = ''
							this.form.enterprise = ''
							this.form.status = ''
							this.form.work_type = ''
							this.form.scope = ''
							this.form.jobexperience = ''
							this.form.xueli = ''
							this.form.qytpa = ''
							this.form.zstpa = ''
							this.selectProv = ''
							this.selectCity = ''
							this.form.jobexperience = ''
							this.form.picture = ''
							this.form.fuli = ''
							this.form.content = ''
							this.form.phone = ''
							this.form.email = ''
							this.form.age = ''
							this.form.xueli = ''
							this.form.zhuanye = ''
							this.form.money = ''
							this.form.name = ''
							this.form.advantage = ''
							this.form.position = ''
							this.form.experience = ''
							this.form.xm_experience = ''
							this.form.qualification = ''
							this.form.homepage = ''
							this.form.applynum = ''
							this.form.volunteer = ''
						}
					} else if (this.cid == '10') {
						let qbe1 = await http.post('api/Common/edit', {
							model: 'hr',
							type: 'content',
							mid: '9',
							title: this.form.title,
							name: this.form.name,
							age: this.form.age,
							picture: this.form.picture,
							applynum:this.form.applynum,
							volunteer: this.form.volunteer,
							homepage: this.form.homepage,
							qualification: this.form.qualification,
							experience: this.form.experience,
							position: this.form.position,
							advantage: this.form.advantage,
							email: this.form.email,
							phone: this.form.phone,
							personl_picture:this.form.personl_picture,
							status:this.form.status,
							zhuanye: this.form.zhuanye,
							xueli: this.form.xueli,
							content: this.form.content,
							jobexperience: this.form.jobexperience,
							fuli: this.form.fuli,
							money: this.form.money,
							zhanshi_img: this.form.zhanshi_img,
							qiye_img: this.form.qiye_img,
							xueli: this.form.xueli,
							city: this.city,
							province:this.province,
							jobexperience: this.form.jobexperience,
							scope: this.form.scope,
							work_type: this.form.work_type,
							enterprise: this.form.enterprise,
							fid: this.form.fid,
							uid: loginInfo.id,
							id: this.qid,
						})
						if (qbe1.data.code == 200) {
							this.$notify({
								title: '成功',
								message: '上传成功',
								type: 'success'
							});
							this.fileLists = []
							this.fileListss = []
							this.fileListssq = []
							this.fileListssqss = []
							this.form.title = ''
							this.form.fid = ''
							this.form.enterprise = ''
							this.form.work_type = ''
							this.form.scope = ''
							this.city= ''
							this.province = ''
							this.form.jobexperience = ''
							this.form.xueli = ''
							this.form.qytpa = ''
							this.form.applynum = ''
							this.form.status = ''
							this.form.zstpa = ''
							this.form.jobexperience = ''
							this.form.picture = ''
							this.form.fuli = ''
							this.form.content = ''
							this.form.phone = ''
							this.form.email = ''
							this.form.age = ''
							this.form.xueli = ''
							this.form.zhuanye = ''
							this.form.money = ''
							this.form.name = ''
							this.form.advantage = ''
							this.form.position = ''
							this.form.experience = ''
							this.selectProv = ''
							this.selectCity = ''
							this.form.xm_experience = ''
							this.form.qualification = ''
							this.form.homepage = ''
							this.form.volunteer = ''
						}
					}
				} else if (this.xsa == false) {
					if (this.cid == '9') {
						let res1 = await http.post('api/Common/add', {
							model: 'hr',
							type: 'content',
							mid: '10',
							title: this.form.title,
							name: this.form.name,
							age: this.form.age,
							picture: this.form.picture,
							volunteer: this.form.volunteer,
							homepage: this.form.homepage,
							qualification: this.form.qualification,
							experience: this.form.experience,
							position: this.form.position,
							advantage: this.form.advantage,
							email: this.form.email,
							status:this.form.status,
							phone: this.form.phone,
							zhuanye: this.form.zhuanye,
							xueli: this.form.xueli,
							personl_picture:this.form.personl_picture,
							applynum:this.form.applynum,
							content: this.form.content,
							jobexperience: this.form.jobexperience,
							fuli: this.form.fuli,
							money: this.form.money,
							zhanshi_img: this.form.zhanshi_img,
							qiye_img: this.form.qiye_img,
							xueli: this.form.xueli,
							jobexperience: this.form.jobexperience,
							scope: this.form.scope,
							work_type: this.form.work_type,
							enterprise: this.form.enterprise,
							city: this.city,
							province:this.province,
							fid: this.form.fid,
							uid: loginInfo.id
						})
						if (res1.data.code == 200) {
							this.$notify({
								title: '成功',
								message: '上传成功',
								type: 'success'
							});
							this.fileLists = []
							this.fileListss = []
							this.fileListssq = []
							this.fileListssqss = []
							this.form.title = ''
							this.form.fid = ''
							this.form.enterprise = ''
							this.form.work_type = ''
							this.form.scope = ''
							this.form.applynum = ''
							this.form.jobexperience = ''
							this.form.status = ''
							this.form.xueli = ''
							this.form.qytpa = ''
							this.form.zstpa = ''
							this.selectProv = ''
							this.selectCity = ''
							this.city= ''
							this.province = ''
							this.form.jobexperience = ''
							this.form.picture = ''
							this.form.fuli = ''
							this.form.content = ''
							this.form.phone = ''
							this.form.email = ''
							this.form.age = ''
							this.form.xueli = ''
							this.form.zhuanye = ''
							this.form.money = ''
							this.form.name = ''
							this.form.advantage = ''
							this.form.position = ''
							this.form.experience = ''
							this.form.xm_experience = ''
							this.form.qualification = ''
							this.form.homepage = ''
							this.form.volunteer = ''
						}
					} else if (this.cid == '10') {
						let res2 = await http.post('api/Common/add', {
							model: 'hr',
							type: 'content',
							mid: '9',
							title: this.form.title,
							name: this.form.name,
							age: this.form.age,
							picture: this.form.picture,
							volunteer: this.form.volunteer,
							homepage: this.form.homepage,
							qualification: this.form.qualification,
							experience: this.form.experience,
							position: this.form.position,
							advantage: this.form.advantage,
							email: this.form.email,
							applynum:this.form.applynum, 
							phone: this.form.phone,
							zhuanye: this.form.zhuanye,
							xueli: this.form.xueli,
							status:this.form.status,
							content: this.form.content,
							jobexperience: this.form.jobexperience,
							fuli: this.form.fuli,
							money: this.form.money,
							city: this.city,
							province:this.province,
							zhanshi_img: this.form.zhanshi_img,
							qiye_img: this.form.qiye_img,
							xueli: this.form.xueli,
							personl_picture:this.form.personl_picture,
							jobexperience: this.form.jobexperience,
							scope: this.form.scope,
							work_type: this.form.work_type,
							enterprise: this.form.enterprise,
							fid: this.form.fid,
							uid: loginInfo.id
						})
						if (res2.data.code == 200) {
							this.$notify({
								title: '成功',
								message: '上传成功',
								type: 'success'
							});
							this.fileLists = []
							this.fileListss = []
							this.fileListssq = []
							this.fileListssqss = []
							this.form.title = ''
							this.form.fid = ''
							this.city= ''
							this.form.status = ''
							this.province = ''
							this.form.enterprise = ''
							this.form.work_type = ''
							this.form.scope = ''
							this.selectProv = ''
							this.form.applynum = ''
							this.selectCity = ''
							this.form.jobexperience = ''
							this.form.xueli = ''
							this.form.qytpa = ''
							this.form.zstpa = ''
							this.form.jobexperience = ''
							this.form.picture = ''
							this.form.fuli = ''
							this.form.content = ''
							this.form.phone = ''
							this.form.email = ''
							this.form.age = ''
							this.form.xueli = ''
							this.form.zhuanye = ''
							this.form.money = ''
							this.form.name = ''
							this.form.advantage = ''
							this.form.position = ''
							this.form.experience = ''
							this.form.xm_experience = ''
							this.form.qualification = ''
							this.form.homepage = ''
							this.form.volunteer = ''
						}
					}
				}
			},
			async detela(id, mid) {
				let res = await http.post('api/Common/delete', {
					model: 'hr',
					type: 'content',
					mid: mid,
					field_name: 'id',
					field_id: id
				})
				if (res.data.code == 200) {
					this.$notify({
						title: '成功',
						message: '删除成功',
						type: 'success'
					});
					this.gotosb()
				}
			},
			xiugaia(val) {
				console.log(val)
				console.log(this.form.zstpa)
				this.fileLists = []
				this.fileListss = []
				this.fileListssq = []
				this.fileListssqss = []
				this.xsa = true
				if (this.cid == '6') {
					this.cid = '9'
				} else if (this.cid == '7') {
					this.cid = '10'
				}
				this.qid = val.id
				this.city = val.city
				this.selectProv = val.province
				this.selectCity = val.city
				this.province = val.province
				this.form.title = val.title
				this.form.picture = val.picture
				this.form.volunteer = val.volunteer
				this.form.homepage = val.homepage
				this.form.qualification = val.qualification
				this.form.position = val.position
				this.form.applynum = val.applynum
				this.form.advantage = val.advantage
				this.form.email = val.email
				this.form.phone = val.phone
				this.form.zhuanye = val.zhuanye
				this.form.xueli = val.xueli
				this.form.experience = val.experience
				this.form.age = val.age
				this.form.status = val.status
				this.form.name = val.name
				this.form.content = val.content
				this.form.xueli = val.xueli
				this.form.fid = parseInt(val.fid)
				this.form.enterprise = val.enterprise
				this.form.work_type = val.work_type
				this.form.scope = val.scope
				this.form.jobexperience = val.jobexperience
				this.form.money = val.money
				this.form.jobexperience = val.jobexperience
				this.form.qytpa = val.qiye_img
				this.form.zstpa = val.zhanshi_img
				this.form.fuli = val.fuli
				this.form.personl_picture = val.personl_picture
				
				if(this.form.picture === 'http://admin.shipoe360.com/public/'){
					this.form.picture = ''
				} else {
					this.form.picture = this.form.picture.replace(new RegExp('http://admin.shipoe360.com/public/','g'),'')
				}
				
				if(this.form.personl_picture === 'http://admin.shipoe360.com/public/'){
					this.form.personl_picture = ''
				} else {
					this.form.personl_picture = this.form.personl_picture.replace(new RegExp('http://admin.shipoe360.com/public/','g'),'')
				}
				
				if(this.form.qiye_img === 'http://admin.shipoe360.com/public/'){
					this.form.qiye_img = ''
				} else {
					this.form.qiye_img = this.form.qiye_img.replace(new RegExp('http://admin.shipoe360.com/public/','g'),'')
				}
				
				if(this.form.zhanshi_img === 'http://admin.shipoe360.com/public/'){
					this.form.zhanshi_img = ''
				} else {
					this.form.zhanshi_img = this.form.zhanshi_img.replace(new RegExp('http://admin.shipoe360.com/public/','g'),'')
				}

				let fileArrssq = [];
				let fileObjssq = {};
				fileObjssq.name = "图片";
				fileObjssq.zstpa = val.picture;
				fileArrssq.push(fileObjssq);
				this.fileListssq = fileArrssq

				let fileArrss = [];
				let fileObjss = {};
				fileObjss.name = "图片";
				fileObjss.zstpa = val.zhanshi_img;
				fileArrss.push(fileObjss);
				this.fileListss = fileArrss

				let fileArrs = [];
				let fileObjs = {};
				fileObjs.name = "图片";
				fileObjs.zstpa = val.qiye_img;
				fileArrs.push(fileObjs);
				this.fileLists = fileArrs
				
				let fileArrssss = [];
				let fileObjssss = {};
				fileObjssss.name = "微信二维码";
				fileObjssss.zstpa = val.personl_picture;
				fileArrssss.push(fileObjssss);
				this.fileListssqss = fileArrssss
			},
			async handleCurrentChange(val) {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (this.cid == '6') {
					let res = await http.get('api/picture/personl_page_zp', {
						uid: loginInfo.id,
						page: val
					})
					console.log(res)
					this.rczpa = res.data.data.list
					this.Totals = res.data.data.count
					this.PageSize = res.data.data.rows_limit
				} else if (this.cid == '7') {
					let res = await http.get('api/picture/personl_page_jl', {
						uid: loginInfo.id,
						page: val
					})
					console.log(res)
					this.rczpa = res.data.data.list
					this.Totals = res.data.data.count
					this.PageSize = res.data.data.rows_limit
				}

			},
			/*二级联动选择地区*/
			getProv: function(prov) {
				let tempCity = [];
				this.citys = [];
				this.selectCity = '';
				let allCity = [{
						prov: "北京市",
						label: "北京市"
					},
					{
						prov: "天津市",
						label: "天津市"
					},
					{
						prov: "河北省",
						label: "石家庄市"
					},
					{
						prov: "河北省",
						label: "唐山市"
					},
					{
						prov: "河北省",
						label: "秦皇岛市"
					},
					{
						prov: "河北省",
						label: "邯郸市"
					},
					{
						prov: "河北省",
						label: "邢台市"
					},
					{
						prov: "河北省",
						label: "保定市"
					},
					{
						prov: "河北省",
						label: "张家口市"
					},
					{
						prov: "河北省",
						label: "承德市"
					},
					{
						prov: "河北省",
						label: "沧州市"
					},
					{
						prov: "河北省",
						label: "廊坊市"
					},
					{
						prov: "河北省",
						label: "衡水市"
					},
					{
						prov: "山西省",
						label: "太原市"
					},
					{
						prov: "山西省",
						label: "大同市"
					},
					{
						prov: "山西省",
						label: "阳泉市"
					},
					{
						prov: "山西省",
						label: "长治市"
					},
					{
						prov: "山西省",
						label: "晋城市"
					},
					{
						prov: "山西省",
						label: "朔州市"
					},
					{
						prov: "山西省",
						label: "晋中市"
					},
					{
						prov: "山西省",
						label: "运城市"
					},
					{
						prov: "山西省",
						label: "忻州市"
					},
					{
						prov: "山西省",
						label: "临汾市"
					},
					{
						prov: "山西省",
						label: "吕梁市"
					},
					{
						prov: "内蒙古自治区",
						label: "呼和浩特市"
					},
					{
						prov: "内蒙古自治区",
						label: "包头市"
					},
					{
						prov: "内蒙古自治区",
						label: "乌海市"
					},
					{
						prov: "内蒙古自治区",
						label: "赤峰市"
					},
					{
						prov: "内蒙古自治区",
						label: "通辽市"
					},
					{
						prov: "内蒙古自治区",
						label: "鄂尔多斯市"
					},
					{
						prov: "内蒙古自治区",
						label: "呼伦贝尔市"
					},
					{
						prov: "内蒙古自治区",
						label: "巴彦淖尔市"
					},
					{
						prov: "内蒙古自治区",
						label: "乌兰察布市"
					},
					{
						prov: "内蒙古自治区",
						label: "兴安盟"
					},
					{
						prov: "内蒙古自治区",
						label: "锡林郭勒盟"
					},
					{
						prov: "内蒙古自治区",
						label: "阿拉善盟"
					},
					{
						prov: "辽宁省",
						label: "沈阳市"
					},
					{
						prov: "辽宁省",
						label: "大连市"
					},
					{
						prov: "辽宁省",
						label: "鞍山市"
					},
					{
						prov: "辽宁省",
						label: "抚顺市"
					},
					{
						prov: "辽宁省",
						label: "本溪市"
					},
					{
						prov: "辽宁省",
						label: "丹东市"
					},
					{
						prov: "辽宁省",
						label: "锦州市"
					},
					{
						prov: "辽宁省",
						label: "营口市"
					},
					{
						prov: "辽宁省",
						label: "阜新市"
					},
					{
						prov: "辽宁省",
						label: "辽阳市"
					},
					{
						prov: "辽宁省",
						label: "盘锦市"
					},
					{
						prov: "辽宁省",
						label: "铁岭市"
					},
					{
						prov: "辽宁省",
						label: "朝阳市"
					},
					{
						prov: "辽宁省",
						label: "葫芦岛市"
					},
					{
						prov: "吉林省",
						label: "长春市"
					},
					{
						prov: "吉林省",
						label: "吉林市"
					},
					{
						prov: "吉林省",
						label: "四平市"
					},
					{
						prov: "吉林省",
						label: "辽源市"
					},
					{
						prov: "吉林省",
						label: "通化市"
					},
					{
						prov: "吉林省",
						label: "白山市"
					},
					{
						prov: "吉林省",
						label: "松原市"
					},
					{
						prov: "吉林省",
						label: "白城市"
					},
					{
						prov: "吉林省",
						label: "延边朝鲜族自治州"
					},
					{
						prov: "黑龙江省",
						label: "哈尔滨市"
					},
					{
						prov: "黑龙江省",
						label: "齐齐哈尔市"
					},
					{
						prov: "黑龙江省",
						label: "鸡西市"
					},
					{
						prov: "黑龙江省",
						label: "鹤岗市"
					},
					{
						prov: "黑龙江省",
						label: "双鸭山市"
					},
					{
						prov: "黑龙江省",
						label: "大庆市"
					},
					{
						prov: "黑龙江省",
						label: "伊春市"
					},
					{
						prov: "黑龙江省",
						label: "佳木斯市"
					},
					{
						prov: "黑龙江省",
						label: "七台河市"
					},
					{
						prov: "黑龙江省",
						label: "牡丹江市"
					},
					{
						prov: "黑龙江省",
						label: "黑河市"
					},
					{
						prov: "黑龙江省",
						label: "绥化市"
					},
					{
						prov: "黑龙江省",
						label: "大兴安岭地区"
					},
					{
						prov: "上海市",
						label: "上海市"
					},
					{
						prov: "江苏省",
						label: "南京市"
					},
					{
						prov: "江苏省",
						label: "无锡市"
					},
					{
						prov: "江苏省",
						label: "徐州市"
					},
					{
						prov: "江苏省",
						label: "常州市"
					},
					{
						prov: "江苏省",
						label: "苏州市"
					},
					{
						prov: "江苏省",
						label: "南通市"
					},
					{
						prov: "江苏省",
						label: "连云港市"
					},
					{
						prov: "江苏省",
						label: "淮安市"
					},
					{
						prov: "江苏省",
						label: "盐城市"
					},
					{
						prov: "江苏省",
						label: "扬州市"
					},
					{
						prov: "江苏省",
						label: "镇江市"
					},
					{
						prov: "江苏省",
						label: "泰州市"
					},
					{
						prov: "江苏省",
						label: "宿迁市"
					},
					{
						prov: "浙江省",
						label: "杭州市"
					},
					{
						prov: "浙江省",
						label: "宁波市"
					},
					{
						prov: "浙江省",
						label: "温州市"
					},
					{
						prov: "浙江省",
						label: "嘉兴市"
					},
					{
						prov: "浙江省",
						label: "湖州市"
					},
					{
						prov: "浙江省",
						label: "绍兴市"
					},
					{
						prov: "浙江省",
						label: "金华市"
					},
					{
						prov: "浙江省",
						label: "衢州市"
					},
					{
						prov: "浙江省",
						label: "舟山市"
					},
					{
						prov: "浙江省",
						label: "台州市"
					},
					{
						prov: "浙江省",
						label: "丽水市"
					},
					{
						prov: "安徽省",
						label: "合肥市"
					},
					{
						prov: "安徽省",
						label: "芜湖市"
					},
					{
						prov: "安徽省",
						label: "蚌埠市"
					},
					{
						prov: "安徽省",
						label: "淮南市"
					},
					{
						prov: "安徽省",
						label: "马鞍山市"
					},
					{
						prov: "安徽省",
						label: "淮北市"
					},
					{
						prov: "安徽省",
						label: "铜陵市"
					},
					{
						prov: "安徽省",
						label: "安庆市"
					},
					{
						prov: "安徽省",
						label: "黄山市"
					},
					{
						prov: "安徽省",
						label: "滁州市"
					},
					{
						prov: "安徽省",
						label: "阜阳市"
					},
					{
						prov: "安徽省",
						label: "宿州市"
					},
					{
						prov: "安徽省",
						label: "六安市"
					},
					{
						prov: "安徽省",
						label: "亳州市"
					},
					{
						prov: "安徽省",
						label: "池州市"
					},
					{
						prov: "安徽省",
						label: "宣城市"
					},
					{
						prov: "福建省",
						label: "福州市"
					},
					{
						prov: "福建省",
						label: "厦门市"
					},
					{
						prov: "福建省",
						label: "莆田市"
					},
					{
						prov: "福建省",
						label: "三明市"
					},
					{
						prov: "福建省",
						label: "泉州市"
					},
					{
						prov: "福建省",
						label: "漳州市"
					},
					{
						prov: "福建省",
						label: "南平市"
					},
					{
						prov: "福建省",
						label: "龙岩市"
					},
					{
						prov: "福建省",
						label: "宁德市"
					},
					{
						prov: "江西省",
						label: "南昌市"
					},
					{
						prov: "江西省",
						label: "景德镇市"
					},
					{
						prov: "江西省",
						label: "萍乡市"
					},
					{
						prov: "江西省",
						label: "九江市"
					},
					{
						prov: "江西省",
						label: "新余市"
					},
					{
						prov: "江西省",
						label: "鹰潭市"
					},
					{
						prov: "江西省",
						label: "赣州市"
					},
					{
						prov: "江西省",
						label: "吉安市"
					},
					{
						prov: "江西省",
						label: "宜春市"
					},
					{
						prov: "江西省",
						label: "抚州市"
					},
					{
						prov: "江西省",
						label: "上饶市"
					},
					{
						prov: "山东省",
						label: "济南市"
					},
					{
						prov: "山东省",
						label: "青岛市"
					},
					{
						prov: "山东省",
						label: "淄博市"
					},
					{
						prov: "山东省",
						label: "枣庄市"
					},
					{
						prov: "山东省",
						label: "东营市"
					},
					{
						prov: "山东省",
						label: "烟台市"
					},
					{
						prov: "山东省",
						label: "潍坊市"
					},
					{
						prov: "山东省",
						label: "济宁市"
					},
					{
						prov: "山东省",
						label: "泰安市"
					},
					{
						prov: "山东省",
						label: "威海市"
					},
					{
						prov: "山东省",
						label: "日照市"
					},
					{
						prov: "山东省",
						label: "莱芜市"
					},
					{
						prov: "山东省",
						label: "临沂市"
					},
					{
						prov: "山东省",
						label: "德州市"
					},
					{
						prov: "山东省",
						label: "聊城市"
					},
					{
						prov: "山东省",
						label: "滨州市"
					},
					{
						prov: "山东省",
						label: "菏泽市"
					},
					{
						prov: "河南省",
						label: "郑州市"
					},
					{
						prov: "河南省",
						label: "开封市"
					},
					{
						prov: "河南省",
						label: "洛阳市"
					},
					{
						prov: "河南省",
						label: "平顶山市"
					},
					{
						prov: "河南省",
						label: "安阳市"
					},
					{
						prov: "河南省",
						label: "鹤壁市"
					},
					{
						prov: "河南省",
						label: "新乡市"
					},
					{
						prov: "河南省",
						label: "焦作市"
					},
					{
						prov: "河南省",
						label: "濮阳市"
					},
					{
						prov: "河南省",
						label: "许昌市"
					},
					{
						prov: "河南省",
						label: "漯河市"
					},
					{
						prov: "河南省",
						label: "三门峡市"
					},
					{
						prov: "河南省",
						label: "南阳市"
					},
					{
						prov: "河南省",
						label: "商丘市"
					},
					{
						prov: "河南省",
						label: "信阳市"
					},
					{
						prov: "河南省",
						label: "周口市"
					},
					{
						prov: "河南省",
						label: "驻马店市"
					},
					{
						prov: "河南省",
						label: "省直辖县级行政区划"
					},
					{
						prov: "湖北省",
						label: "武汉市"
					},
					{
						prov: "湖北省",
						label: "黄石市"
					},
					{
						prov: "湖北省",
						label: "十堰市"
					},
					{
						prov: "湖北省",
						label: "宜昌市"
					},
					{
						prov: "湖北省",
						label: "襄阳市"
					},
					{
						prov: "湖北省",
						label: "鄂州市"
					},
					{
						prov: "湖北省",
						label: "荆门市"
					},
					{
						prov: "湖北省",
						label: "孝感市"
					},
					{
						prov: "湖北省",
						label: "荆州市"
					},
					{
						prov: "湖北省",
						label: "黄冈市"
					},
					{
						prov: "湖北省",
						label: "咸宁市"
					},
					{
						prov: "湖北省",
						label: "随州市"
					},
					{
						prov: "湖北省",
						label: "恩施土家族苗族自治州"
					},
					{
						prov: "湖北省",
						label: "省直辖县级行政区划"
					},
					{
						prov: "湖北省",
						label: "仙桃市"
					},
					{
						prov: "湖北省",
						label: "潜江市"
					},
					{
						prov: "湖北省",
						label: "天门市"
					},
					{
						prov: "湖北省",
						label: "神农架林区"
					},
					{
						prov: "湖南省",
						label: "长沙市"
					},
					{
						prov: "湖南省",
						label: "株洲市"
					},
					{
						prov: "湖南省",
						label: "湘潭市"
					},
					{
						prov: "湖南省",
						label: "衡阳市"
					},
					{
						prov: "湖南省",
						label: "邵阳市"
					},
					{
						prov: "湖南省",
						label: "岳阳市"
					},
					{
						prov: "湖南省",
						label: "常德市"
					},
					{
						prov: "湖南省",
						label: "张家界市"
					},
					{
						prov: "湖南省",
						label: "益阳市"
					},
					{
						prov: "湖南省",
						label: "郴州市"
					},
					{
						prov: "湖南省",
						label: "永州市"
					},
					{
						prov: "湖南省",
						label: "怀化市"
					},
					{
						prov: "湖南省",
						label: "娄底市"
					},
					{
						prov: "湖南省",
						label: "湘西土家族苗族自治州"
					},
					{
						prov: "广东省",
						label: "广州市"
					},
					{
						prov: "广东省",
						label: "韶关市"
					},
					{
						prov: "广东省",
						label: "深圳市"
					},
					{
						prov: "广东省",
						label: "珠海市"
					},
					{
						prov: "广东省",
						label: "汕头市"
					},
					{
						prov: "广东省",
						label: "佛山市"
					},
					{
						prov: "广东省",
						label: "江门市"
					},
					{
						prov: "广东省",
						label: "湛江市"
					},
					{
						prov: "广东省",
						label: "茂名市"
					},
					{
						prov: "广东省",
						label: "肇庆市"
					},
					{
						prov: "广东省",
						label: "惠州市"
					},
					{
						prov: "广东省",
						label: "梅州市"
					},
					{
						prov: "广东省",
						label: "汕尾市"
					},
					{
						prov: "广东省",
						label: "河源市"
					},
					{
						prov: "广东省",
						label: "阳江市"
					},
					{
						prov: "广东省",
						label: "清远市"
					},
					{
						prov: "广东省",
						label: "东莞市"
					},
					{
						prov: "广东省",
						label: "中山市"
					},
					{
						prov: "广东省",
						label: "潮州市"
					},
					{
						prov: "广东省",
						label: "揭阳市"
					},
					{
						prov: "广东省",
						label: "云浮市"
					},
					{
						prov: "广西壮族自治区",
						label: "南宁市"
					},
					{
						prov: "广西壮族自治区",
						label: "柳州市"
					},
					{
						prov: "广西壮族自治区",
						label: "桂林市"
					},
					{
						prov: "广西壮族自治区",
						label: "梧州市"
					},
					{
						prov: "广西壮族自治区",
						label: "北海市"
					},
					{
						prov: "广西壮族自治区",
						label: "防城港市"
					},
					{
						prov: "广西壮族自治区",
						label: "钦州市"
					},
					{
						prov: "广西壮族自治区",
						label: "贵港市"
					},
					{
						prov: "广西壮族自治区",
						label: "玉林市"
					},
					{
						prov: "广西壮族自治区",
						label: "百色市"
					},
					{
						prov: "广西壮族自治区",
						label: "贺州市"
					},
					{
						prov: "广西壮族自治区",
						label: "河池市"
					},
					{
						prov: "广西壮族自治区",
						label: "来宾市"
					},
					{
						prov: "广西壮族自治区",
						label: "崇左市"
					},
					{
						prov: "海南省",
						label: "海口市"
					},
					{
						prov: "海南省",
						label: "三亚市"
					},
					{
						prov: "海南省",
						label: "三沙市"
					},
					{
						prov: "海南省",
						label: "省直辖县级行政区划"
					},
					{
						prov: "海南省",
						label: "五指山市"
					},
					{
						prov: "海南省",
						label: "琼海市"
					},
					{
						prov: "海南省",
						label: "儋州市"
					},
					{
						prov: "海南省",
						label: "文昌市"
					},
					{
						prov: "海南省",
						label: "万宁市"
					},
					{
						prov: "海南省",
						label: "东方市"
					},
					{
						prov: "海南省",
						label: "定安县"
					},
					{
						prov: "海南省",
						label: "屯昌县"
					},
					{
						prov: "海南省",
						label: "澄迈县"
					},
					{
						prov: "海南省",
						label: "临高县"
					},
					{
						prov: "海南省",
						label: "白沙黎族自治县"
					},
					{
						prov: "海南省",
						label: "昌江黎族自治县"
					},
					{
						prov: "海南省",
						label: "乐东黎族自治县"
					},
					{
						prov: "海南省",
						label: "陵水黎族自治县"
					},
					{
						prov: "海南省",
						label: "保亭黎族苗族自治县"
					},
					{
						prov: "海南省",
						label: "琼中黎族苗族自治县"
					},
					{
						prov: "重庆市",
						label: "重庆市"
					},
					{
						prov: "四川省",
						label: "成都市"
					},
					{
						prov: "四川省",
						label: "自贡市"
					},
					{
						prov: "四川省",
						label: "攀枝花市"
					},
					{
						prov: "四川省",
						label: "泸州市"
					},
					{
						prov: "四川省",
						label: "德阳市"
					},
					{
						prov: "四川省",
						label: "绵阳市"
					},
					{
						prov: "四川省",
						label: "广元市"
					},
					{
						prov: "四川省",
						label: "遂宁市"
					},
					{
						prov: "四川省",
						label: "内江市"
					},
					{
						prov: "四川省",
						label: "乐山市"
					},
					{
						prov: "四川省",
						label: "南充市"
					},
					{
						prov: "四川省",
						label: "眉山市"
					},
					{
						prov: "四川省",
						label: "宜宾市"
					},
					{
						prov: "四川省",
						label: "广安市"
					},
					{
						prov: "四川省",
						label: "达州市"
					},
					{
						prov: "四川省",
						label: "雅安市"
					},
					{
						prov: "四川省",
						label: "巴中市"
					},
					{
						prov: "四川省",
						label: "资阳市"
					},
					{
						prov: "四川省",
						label: "阿坝藏族羌族自治州"
					},
					{
						prov: "四川省",
						label: "甘孜藏族自治州"
					},
					{
						prov: "四川省",
						label: "凉山彝族自治州"
					},
					{
						prov: "贵州省",
						label: "贵阳市"
					},
					{
						prov: "贵州省",
						label: "六盘水市"
					},
					{
						prov: "贵州省",
						label: "遵义市"
					},
					{
						prov: "贵州省",
						label: "安顺市"
					},
					{
						prov: "贵州省",
						label: "毕节市"
					},
					{
						prov: "贵州省",
						label: "铜仁市"
					},
					{
						prov: "贵州省",
						label: "黔西南布依族苗族自治州"
					},
					{
						prov: "贵州省",
						label: "黔东南苗族侗族自治州"
					},
					{
						prov: "贵州省",
						label: "黔南布依族苗族自治州"
					},
					{
						prov: "云南省",
						label: "昆明市"
					},
					{
						prov: "云南省",
						label: "曲靖市"
					},
					{
						prov: "云南省",
						label: "玉溪市"
					},
					{
						prov: "云南省",
						label: "保山市"
					},
					{
						prov: "云南省",
						label: "昭通市"
					},
					{
						prov: "云南省",
						label: "丽江市"
					},
					{
						prov: "云南省",
						label: "普洱市"
					},
					{
						prov: "云南省",
						label: "临沧市"
					},
					{
						prov: "云南省",
						label: "楚雄彝族自治州"
					},
					{
						prov: "云南省",
						label: "红河哈尼族彝族自治州"
					},
					{
						prov: "云南省",
						label: "文山壮族苗族自治州"
					},
					{
						prov: "云南省",
						label: "西双版纳傣族自治州"
					},
					{
						prov: "云南省",
						label: "大理白族自治州"
					},
					{
						prov: "云南省",
						label: "德宏傣族景颇族自治州"
					},
					{
						prov: "云南省",
						label: "怒江傈僳族自治州"
					},
					{
						prov: "云南省",
						label: "迪庆藏族自治州"
					},
					{
						prov: "西藏自治区",
						label: "拉萨市"
					},
					{
						prov: "西藏自治区",
						label: "昌都地区"
					},
					{
						prov: "西藏自治区",
						label: "山南地区"
					},
					{
						prov: "西藏自治区",
						label: "日喀则地区"
					},
					{
						prov: "西藏自治区",
						label: "那曲地区"
					},
					{
						prov: "西藏自治区",
						label: "阿里地区"
					},
					{
						prov: "西藏自治区",
						label: "林芝地区"
					},
					{
						prov: "陕西省",
						label: "西安市"
					},
					{
						prov: "陕西省",
						label: "铜川市"
					},
					{
						prov: "陕西省",
						label: "宝鸡市"
					},
					{
						prov: "陕西省",
						label: "咸阳市"
					},
					{
						prov: "陕西省",
						label: "渭南市"
					},
					{
						prov: "陕西省",
						label: "延安市"
					},
					{
						prov: "陕西省",
						label: "汉中市"
					},
					{
						prov: "陕西省",
						label: "榆林市"
					},
					{
						prov: "陕西省",
						label: "安康市"
					},
					{
						prov: "陕西省",
						label: "商洛市"
					},
					{
						prov: "甘肃省",
						label: "兰州市"
					},
					{
						prov: "甘肃省",
						label: "嘉峪关市"
					},
					{
						prov: "甘肃省",
						label: "金昌市"
					},
					{
						prov: "甘肃省",
						label: "白银市"
					},
					{
						prov: "甘肃省",
						label: "天水市"
					},
					{
						prov: "甘肃省",
						label: "武威市"
					},
					{
						prov: "甘肃省",
						label: "张掖市"
					},
					{
						prov: "甘肃省",
						label: "平凉市"
					},
					{
						prov: "甘肃省",
						label: "酒泉市"
					},
					{
						prov: "甘肃省",
						label: "庆阳市"
					},
					{
						prov: "甘肃省",
						label: "定西市"
					},
					{
						prov: "甘肃省",
						label: "陇南市"
					},
					{
						prov: "甘肃省",
						label: "临夏回族自治州"
					},
					{
						prov: "甘肃省",
						label: "甘南藏族自治州"
					},
					{
						prov: "青海省",
						label: "西宁市"
					},
					{
						prov: "青海省",
						label: "海东市"
					},
					{
						prov: "青海省",
						label: "海北藏族自治州"
					},
					{
						prov: "青海省",
						label: "黄南藏族自治州"
					},
					{
						prov: "青海省",
						label: "海南藏族自治州"
					},
					{
						prov: "青海省",
						label: "果洛藏族自治州"
					},
					{
						prov: "青海省",
						label: "玉树藏族自治州"
					},
					{
						prov: "青海省",
						label: "海西蒙古族藏族自治州"
					},
					{
						prov: "宁夏回族自治区",
						label: "银川市"
					},
					{
						prov: "宁夏回族自治区",
						label: "石嘴山市"
					},
					{
						prov: "宁夏回族自治区",
						label: "吴忠市"
					},
					{
						prov: "宁夏回族自治区",
						label: "固原市"
					},
					{
						prov: "宁夏回族自治区",
						label: "中卫市"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "乌鲁木齐市"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "克拉玛依市"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "吐鲁番地区"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "哈密地区"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "昌吉回族自治州"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "博尔塔拉蒙古自治州"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "巴音郭楞蒙古自治州"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "阿克苏地区"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "克孜勒苏柯尔克孜自治州"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "喀什地区"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "和田地区"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "伊犁哈萨克自治州"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "塔城地区"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "阿勒泰地区"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "自治区直辖县级行政区划"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "石河子市"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "阿拉尔市"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "图木舒克市"
					},
					{
						prov: "新疆维吾尔自治区",
						label: "五家渠市"
					},
					{
						prov: "台湾省",
						label: "台北市"
					},
					{
						prov: "台湾省",
						label: "高雄市"
					},
					{
						prov: "台湾省",
						label: "基隆市"
					},
					{
						prov: "台湾省",
						label: "台中市"
					},
					{
						prov: "台湾省",
						label: "台南市"
					},
					{
						prov: "台湾省",
						label: "新竹市"
					},
					{
						prov: "台湾省",
						label: "嘉义市"
					},
					{
						prov: "台湾省",
						label: "省直辖"
					},
					{
						prov: "香港特别行政区",
						label: "香港岛"
					},
					{
						prov: "香港特别行政区",
						label: "九龙"
					},
					{
						prov: "香港特别行政区",
						label: "新界"
					},
					{
						prov: "澳门特别行政区",
						label: "澳门半岛"
					},
					{
						prov: "澳门特别行政区",
						label: "澳门离岛"
					},
					{
						prov: "澳门特别行政区",
						label: "无堂区划分区域"
					}
				];
				for (var val of allCity) {
					if (prov == val.prov) {
						console.log(val.prov);
						this.province = val.prov
						tempCity.push({
							label: val.label,
							value: val.label
						})
					}
				}
				console.log(val.prov);
				this.citys = tempCity;
			},
			getCity: function(city) {
				console.log(city);
				this.city = this.selectCity
				console.log(this.city)
			},
			async gotosb() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (this.cid == '6') {
					let res = await http.post('api/Common/index', {
						model: 'hr',
						type: 'content',
						mid: '10',
						uid: loginInfo.id
					})
					this.rczpa = res.data.data.list.data
					this.Totals = res.data.data.count
					this.PageSize = res.data.data.rows_limit
				} else if (this.cid == '7') {
					let res1 = await http.post('api/Common/index', {
						model: 'hr',
						type: 'content',
						mid: '9',
						uid: loginInfo.id
					})
					this.rczpa = res1.data.data.list.data
					this.Totals = res.data.data.count
					this.PageSize = res.data.data.rows_limit
				}
			}
		}
	}
</script>

<style>
	.czxa {
		width: 200px;
		height: 30px;
		border: 1px solid #000;
		color: #FFF;
		text-align: center;
		line-height: 30px;
		margin-top: 10px;
		float: left;
		margin-left: 5px;
		background-color: rgba(255, 68, 0, 0.3);
	}

	.zxcas {
		width: 200px;
		height: 30px;
		border: 1px solid #000;
		text-align: center;
		line-height: 30px;
		margin-top: 10px;
		float: left;
		margin-left: 5px;
	}
</style>
